<div class="scrollable-container container-fluid">
  <div class="row d-flex justify-content-center align-items-center">
    <div class="col-lg-12 col-12">
      <!-- Bg -->

      <div class="card border-0 shadow-sm rounded overflow-hidden mb-3 bg-light">

  <!-- COVER -->
  <div class="position-relative">
    <div class="banner-box position-relative overflow-hidden" @click="open_image_cover(currentCover)">
      <img v-if="hasCover" :src="currentCover" alt="Profile Cover" class="banner-image" />
      <div v-else class="banner-placeholder d-flex align-items-center justify-content-center text-muted"></div>
    </div>
    <div v-if="isOwner" class="position-absolute bottom-0 end-0 m-3">
      <button type="button"
        class="btn btn-sm bg-white rounded shadow-sm px-3 border-0 d-flex align-items-center gap-2 pointer"
        @click.stop="triggerFileUploadCover">
        <i class="bi bi-camera-fill text-primary"></i>
        <span class="fw-bold small text-dark d-none d-md-inline">Change Banner</span>
      </button>
      <input ref="fileInputCover" type="file" accept="image/*" class="d-none" @change="onCoverPictureChange" />
    </div>
  </div>

  <!-- PROFILE BODY -->
  <div class="card-body pt-0 px-3 px-md-4 pb-4">
    <div class="d-flex flex-column flex-md-row align-items-center align-items-md-end position-relative text-center text-md-start">

      <!-- AVATAR -->
      <div class="position-relative me-md-4 mb-3 mb-md-0 flex-shrink-0 avatar-overlap">
        <div class="profile-avatar bg-white rounded-circle shadow-lg p-1 border border-2 border-white position-relative">

          <!-- Mobile completion ring -->
          <svg v-if="isOwner" class="position-absolute top-0 start-0 w-100 h-100 d-md-none"
            viewBox="0 0 120 120" >
            <circle cx="60" cy="60" r="56" fill="none" stroke="#e9ecef" stroke-width="5"/>
            <circle cx="60" cy="60" r="56" fill="none" stroke="var(--secondary-color)" stroke-width="5"
              stroke-linecap="round"
              :stroke-dasharray="2 * Math.PI * 56"
              :stroke-dashoffset="(2 * Math.PI * 56) * (1 - (profileData.completion_percentage || 0) / 100)"
              transform="rotate(90 60 60) scale(-1 1) translate(-120 0)"/>
          </svg>

          <!-- % badge -->
          <div v-if="isOwner"
          class="d-md-none position-absolute top-0 start-50 translate-middle-x bg-primary text-white rounded-pill px-2 fw-bold shadow-sm border border-2 border-white completion-badge">
          {{ profileData.completion_percentage || 0 }}%
        </div>

          <!-- Image clipped separately -->
          <div class="rounded-circle overflow-hidden w-100 h-100 position-relative">
            <img
              v-if="getPersonalAvatar(profileData)"
              :src="getPersonalAvatar(profileData)"
              class="w-100 h-100 object-fit-cover"
              @click="open_image_viewer(getPersonalAvatar(profileData))"
              alt="Profile Image"
            />
            <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
              <i class="bi bi-person-circle fs-2 text-muted"></i>
            </div>
          </div>
        </div>

        <button v-if="isOwner"
          class="btn btn-primary btn-sm rounded-circle position-absolute bottom-0 end-0 d-flex align-items-center justify-content-center border border-3 border-white shadow"
          
          @click="triggerFileUpload">
          <i class="bi bi-camera-fill"></i>
        </button>
        <input ref="fileInput" type="file" accept="image/*" class="d-none" @change="onProfilePictureChange" />
      </div>

      <!-- NAME + STATS -->
      <div class="flex-grow-1 mb-md-2 mt-2 mt-md-5">

        <div class="d-flex align-items-center gap-2 flex-wrap justify-content-center justify-content-md-start mb-1">
          <h2 class="fw-bold text-dark mb-0 h3">
            {{ display_profile_name }}
          </h2>
          <span v-if="client_features.show_membership && (membership_name && userHasPaid)" class="badge bg-soft-primary text-primary rounded px-3 py-1 fw-bold small">
            <i class="bi bi-patch-check-fill me-1"></i>{{ membership_name }}
          </span>
        </div>

        <div v-if="client_features.show_membership && user_details.user_id === user.user_id" class="mb-2">
          <router-link v-if="membership_available && !userHasPaid && !is_cancelled" to="/view_membership/">
            <button class="btn btn-primary text-xxs rounded btn-sm text-white">
              <i class="bi bi-patch-check"></i> Join Membership
            </button>
          </router-link>
        </div>

        <div class="d-flex align-items-center justify-content-center justify-content-md-start gap-3 mt-1 mb-2">
          <div class="pointer small" @click="get_followers('followers')">
            <span class="fw-bold text-dark">{{ profileData?.followers_count || 0 }}</span>
            <span class="text-muted ms-1">Followers</span>
          </div>
          <div class="vr d-none d-md-block"></div>
          <div class="pointer small" @click="get_followers('following')">
            <span class="fw-bold text-dark">{{ profileData?.following_count || 0 }}</span>
            <span class="text-muted ms-1">Following</span>
          </div>
        </div>

        <div class="d-inline-flex align-items-center gap-2 bg-soft-warning p-1 px-3 rounded border border-warning border-opacity-10 mt-1">
          <div class="text-warning fw-bold small"><i class="bi bi-star-fill me-1"></i>{{ rating || '0.0' }}</div>
          <div class="vr bg-warning opacity-50"></div>
          <button class="btn btn-link p-0 text-dark fw-bold text-xxs text-decoration-underline shadow-none"
            data-bs-toggle="modal" data-bs-target="#ratings-modal">
            {{ total_ratings }} {{ (total_ratings === 0 || total_ratings === 1) ? 'Review' : 'Reviews' }}
          </button>
        </div>
        <div class="mt-1">
                <a v-for="(link, index) in profileData?.social_profiles" :key="index" :href="link.social_link"
                  target="_blank" class="text-decoration-none direct-social-icon me-3  border-white rounded-5"
                  :title="link.social_type?.name">
                  <i :class="[
                    'bi fs-5', 
                    {
                      'instagram': 'bi-instagram text-danger',
                      'facebook': 'bi-facebook text-primary',
                      'linkedin': 'bi-linkedin text-info',
                      'x_twitter': 'bi-twitter-x text-dark',
                      'youtube': 'bi-youtube text-danger',
                      'tiktok': 'bi-tiktok text-dark',
                      'website': 'bi-globe text-secondary'
                    }[link.social_type?.name?.toLowerCase()] || 'bi-link text-muted'
                  ]"></i>
                </a>
                <button v-if="isOwner" type="button"
                  class="btn btn-link p-0 text-dark fw-bold text-xxs text-decoration-underline shadow-none"
                  data-bs-toggle="modal" data-bs-target="#social_modal">
                  + add Socials
                </button>
              </div>
      </div>
      
      <!-- ACTIONS -->
      <div class="d-flex flex-column align-items-center align-items-md-end gap-2 mt-3 mt-md-0 ms-md-3">

        <div v-if="isOwner" class="d-none d-md-flex align-items-center gap-3 p-2 px-3 bg-light rounded border shadow-sm mb-2">
          <div class="circular-progress-container position-relative">
            <svg class="position-absolute top-0 start-0 w-100 h-100" viewBox="0 0 120 120">
              <circle cx="60" cy="60" r="54" fill="none" stroke="#e9ecef" stroke-width="8"/>
              <circle cx="60" cy="60" r="54" fill="none" stroke="currentColor" stroke-width="8"
                stroke-linecap="round"
                :stroke-dasharray="2 * Math.PI * 54"
                :stroke-dashoffset="circleOffset"
                transform="rotate(90 60 60) scale(-1 1) translate(-120 0)" />
            </svg>
            <div class="position-absolute top-50 start-50 translate-middle text-center">
              <span class="fw-bold text-primary text-xxs">{{ profileData?.completion_percentage || 0 }}%</span>
            </div>
          </div>
          <div class="text-start">
            <p class="text-xxs fw-bold text-muted text-uppercase mb-0">Profile</p>
            <p class="text-xxs fw-black text-primary mb-0">Completed</p>
          </div>
        </div>

        <div class="d-flex flex-row flex-md-column gap-2 justify-content-center">

            <button v-if="String(profileData?.base_profile?.creater?.id) !== String(user_details.user_id)"
              class="btn btn-secondary btn-sm rounded px-3 fw-bold border-0 shadow-sm"
              @click="follow_profile(profileData?.base_profile?.id)">
              <i class="bi me-1" :class="profileData?.is_following ? 'bi-check-lg' : 'bi-plus'"></i>
              {{ profileData?.is_following ? 'Following' : 'Follow' }}
            </button>

            <button v-if="String(profileData?.base_profile?.creater?.id) === String(user_details.user_id)"
             class="btn btn-primary btn-sm rounded px-3 px-md-4 border-0 shadow-sm text-xxs d-none"
                @click="is_owner_view = !is_owner_view">
                <i class="bi me-1" :class="is_owner_view ? 'bi-person-badge' : 'bi-eye'"></i>
                {{ is_owner_view ? 'Manage' : 'Preview' }}

              </button>

            <button v-if="(client_features.show_business_profiles && (String(profileData?.base_profile?.creater?.id) === String(user_details.user_id)))"
              class="btn btn-primary btn-sm rounded px-3 border-0 shadow-sm text-white text-xxs"
              data-bs-toggle="modal" data-bs-target="#company_profile_modal">
              <i class="bi bi-briefcase me-1"></i>Add Business
            </button>

          </div>
      </div>

    </div>
  </div>
</div>

   </div>

     <div v-if="!dwypd_domain && !workbook_domain && isOwner && (userHasPaid || is_cancelled)" class="col-lg-12 col-12">

      <div class="card border border-light-subtle rounded mt-4">
        <button @click="subscriptionExpanded = !subscriptionExpanded"
          class="btn btn-link text-decoration-none w-100 d-flex justify-content-between align-items-center p-3 text-start text-dark fw-semibold">
          <span>Subscription details</span>
          <i :class="subscriptionExpanded ? 'bi bi-chevron-up' : 'bi bi-chevron-down'" class="text-muted"></i>
        </button>

        <div v-show="subscriptionExpanded" class="border-top px-3 pb-3">
          <div class="row g-3 mt-2">
            <div class="col-md-4">
              <div class="small fw-medium text-secondary mb-1">Plan Type</div>
              <div class="h5 fw-semibold text-primary d-flex align-items-center">
                {{membership_name}}
                <span class="badge bg-secondary bg-opacity-25 text-primary ms-2 small">{{membership_type}}</span>
              </div>
            </div>

            <div class="col-md-4">
              <div class="small fw-medium text-secondary mb-1">Status</div>
              <div class="d-flex align-items-center">
                <div :class="[
                    'rounded-circle me-2',
                    is_active ? 'bg-success' : 'bg-danger'
                  ]" style="width: 8px; height: 8px;"></div>
                <span :class="['fw-semibold', is_active ? 'text-success' : 'text-danger']">
                  {{ is_active ? 'Active' : 'Inactive' }}
                </span>
              </div>
            </div>


            <div class="col-md-4">
              <div class="small fw-medium text-secondary mb-1">Frequency</div>
              <div class="text-dark fw-medium">{{billing_cycle}}</div>
            </div>
          </div>

          <div class="border-top mt-3 pt-3">
            <div class="d-flex justify-content-between align-items-center">
              <div v-if="is_active">
                <div class="small fw-medium text-secondary mb-1">Renews on</div>
                <div class="text-dark fw-medium">{{formatDate(renewal_date)}}</div>
              </div>
              <div>
                <button class="btn btn-primary btn-sm shadow" data-bs-toggle="modal" data-bs-target="#manage-subscription-modal">
                  Manage Subscription
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-12 mt-0">
      <div class="bg-light rounded-top shadow-sm px-3 py-2 d-none">
        <div class="scrollable-tabs">
          <ul class="nav nav-pills gap-2" id="businessProfileTabs" role="tablist">
            <!-- Static Tabs -->

            <li class="nav-item" role="presentation">
              <button class="nav-link text-xxs fw-500 px-4" :class="{ active: activeTab === 'about' }" id="about_tab"
                data-bs-toggle="tab" data-bs-target="#about" type="button" role="tab" aria-controls="about"
                aria-selected="activeTab === 'about'" @click="activeTab = 'posts'">
                About
              </button>
            </li>
            <!-- Dynamic Section Tabs -->
            <li v-for="section in all_section" :key="section.sectionId" class="nav-item d-none" role="presentation">
            <!-- {{section}} -->
              <button class="nav-link text-xxs fw-500 px-4"
              :class="{ active: activeTab === ('section_' + section.sectionId) }":id="'section_' + section.sectionId + '_tab'" data-bs-toggle="tab" :data-bs-target="'#section_' + section.sectionId" type="button"
              role="tab" :aria-controls="'section_' + section.sectionId" :aria-selected="activeTab === ('section_' + section.sectionId)"@click="on_dynamic_tab_click(section)">
              <span v-if="section.section?.is_locked">
              <i class="bx bx-lock-alt me-1" title="Locked"></i>
            </span>
              {{ section.section?.name }}
            </button>
          </li>
          </ul>
        </div>
      </div>
      <div>
      <div class="row">

      <div class="col-lg-3">

  <!-- ── DESKTOP (xl+) ── -->
        <div class="d-none d-xl-block">

          <!-- Associated Businesses -->
          <div v-if="(client_features.show_business_profiles && filtered_profiles.length)"
            class="card bg-transparent border rounded shadow-sm p-4 mb -4">
            <h6 class="card-header text-muted bg-transparent mb-3">Associated Businesses</h6>
            <div class="scrollable-tabs">
              <div class="business-list-wrapper align-items-start">
                <div
                  v-for="profile in filtered_profiles"
                  :key="profile.base_profile?.id"
                  class="business-row text-start pointer border rounded shadow-sm d-flex align-items-center justify-content-between py-1 mb-2"
                  @click="open_business_profile(profile)">
                  <h6 class="btn text-xs mb-0 fw-bold">{{ profile.profile_name }}</h6>
                  <i class="bi bi-chevron-right text-muted me-2"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Profile Information -->
          <div v-if="has_visible_profile_information()" class="card bg-transparent border rounded shadow-sm p-4 mb-4">
            <h6 class="card-header text-muted bg-transparent mb-3">Profile Information</h6>

            <div v-if="can_show_profile_field('show_email', profileData.email)" class="bg-transparent rounded py-3 my-1 border">
              <div class="row">
                <div class="col-md-6 text-primary text-xxs">
                  <i class='bx bxs-envelope fs-6 mx-2 text-primary'></i><strong>Email:</strong>
                </div>
                <div class="col-md-6">
                  <p class="mx-2 text-xxs text-end text-md-start mb-0">
                    <span>{{ profileData.email || '' }}</span>
                    <span v-if="isOwner">
                      <i v-if="isValidField(profileData.email)"
                        :class="[profileData.visibility?.show_email === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                        @click="open_visibility_modal('show_email')"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div v-if="can_show_profile_field('show_date_of_birth', profileData.date_of_birth)" class="bg-transparent rounded py-3 my-1 border">
              <div class="row">
                <div class="col-md-6 text-primary text-xxs">
                  <i class='bx bxs-calendar fs-5 mx-2 text-primary'></i><strong>Date of Birth:</strong>
                </div>
                <div class="col-md-6">
                  <p class="mx-2 text-xxs text-end text-md-start mb-0">
                    <span v-if="isOwner || profileData.visibility?.show_date_of_birth === true">
                      {{ is_valid_value(profileData.date_of_birth) ? profileData.date_of_birth : '' }}
                    </span>
                    <span v-if="isOwner">
                      <i v-if="isValidField(profileData.date_of_birth)"
                        :class="[profileData.visibility?.show_date_of_birth === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                        @click="open_visibility_modal('show_date_of_birth')"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div v-if="can_show_profile_location()" class="bg-transparent rounded py-3 my-1 border">
              <div class="row">
                <div class="col-md-6 text-primary text-xxs">
                  <i class='bx bxs-map fs-5 mx-2 text-primary'></i><strong>Address:</strong>
                </div>
                <div class="col-md-6">
                  <p class="mx-2 text-xxs text-end text-md-start mb-0">
                    <span>
                      {{ is_valid_value(profileData.location) ? profileData.location : '' }}
                      <span v-if="profileData.province && profileData.postal_code">, </span>
                      {{ is_valid_value(profileData.province) ? profileData.province : '' }}
                    </span>
                    <span v-if="isOwner">
                      <i v-if="isValidField(profileData.location)"
                        :class="[profileData.visibility?.show_location === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                        @click="open_visibility_modal('show_location')"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <a class="text-xxs fw-bold pointer text-decoration-none d-block mt-2 text-center text-primary"
            @click="activeTab = activeTab === 'about' ? 'posts' : 'about'">
            {{ activeTab === 'about' ? 'See less' : 'See more' }}
            <i class="bi" :class="activeTab === 'about' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </a>
          </div>

        </div>

        <!-- ── MOBILE / TABLET (below xl) ── -->
        <div class="d-block d-xl-none mt-3">

          <!-- Associated Businesses -->
          <div v-if="filtered_profiles.length && !dwypd_domain || (filtered_profiles.length && cbo_domain && user_details.user_role === 'admin')"
            class="card border rounded shadow-sm p-2 mb-2 bg-transparent">
            <h6 class="fw-bold text-muted mb-2 text-xxs">Associated Businesses</h6>
            <div class="business-list-wrapper">
              <div
                v-for="profile in filtered_profiles"
                :key="profile.base_profile?.id"
                class="business-row text-start pointer border rounded d-flex align-items-center justify-content-between py-1 mb-1"
                @click="open_business_profile(profile)">
                <h6 class="btn text-xxs mb-0 fw-bold py-0">{{ profile.profile_name }}</h6>
                <i class="bi bi-chevron-right text-muted me-2"></i>
              </div>
            </div>
          </div>

          <!-- Profile Information -->
          <div v-if="has_visible_profile_information()" class="card border rounded shadow-sm p-2 mb-2 bg-transparent">
            <h6 class="fw-bold text-muted mb-2 text-xxs">Profile Information</h6>

            <div v-if="can_show_profile_field('show_email', profileData.email)" class="bg-transparent rounded py-1 my-1 border">
              <div class="row g-0 align-items-center">
                <div class="col-5 text-primary text-xxs px-2">
                  <i class='bx bxs-envelope mx-1 text-primary'></i><strong>Email:</strong>
                </div>
                <div class="col-7">
                  <p class="px-2 text-xxs text-end mb-0">
                    <span>{{ profileData.email || '' }}</span>
                    <span v-if="isOwner">
                      <i v-if="isValidField(profileData.email)"
                        :class="[profileData.visibility?.show_email === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-1 cursor-pointer']"
                        @click="open_visibility_modal('show_email')"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div v-if="can_show_profile_field('show_date_of_birth', profileData.date_of_birth)" class="bg-transparent rounded py-1 my-1 border">
              <div class="row g-0 align-items-center">
                <div class="col-5 text-primary text-xxs px-2">
                  <i class='bx bxs-calendar mx-1 text-primary'></i><strong>Date of Birth:</strong>
                </div>
                <div class="col-7">
                  <p class="px-2 text-xxs text-end mb-0">
                    <span>
                      {{ is_valid_value(profileData.date_of_birth) ? profileData.date_of_birth : '' }}
                    </span>
                    <span v-if="isOwner">
                      <i v-if="isValidField(profileData.date_of_birth)"
                        :class="[profileData.visibility?.show_date_of_birth === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-1 cursor-pointer']"
                        @click="open_visibility_modal('show_date_of_birth')"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div v-if="can_show_profile_location()" class="bg-transparent rounded py-1 my-1 border">
              <div class="row g-0 align-items-center">
                <div class="col-5 text-primary text-xxs px-2">
                  <i class='bx bxs-map mx-1 text-primary'></i><strong>Address:</strong>
                </div>
                <div class="col-7">
                  <p class="px-2 text-xxs text-end mb-0">
                    <span>
                      {{ is_valid_value(profileData.location) ? profileData.location : '' }}
                      <span v-if="profileData.province && profileData.postal_code">, </span>
                      {{ is_valid_value(profileData.province) ? profileData.province : '' }}
                    </span>
                    <span v-if="isOwner">
                      <i v-if="isValidField(profileData.location)"
                        :class="[profileData.visibility?.show_location === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-1 cursor-pointer']"
                        @click="open_visibility_modal('show_location')"></i>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <a class="text-xxs fw-bold pointer text-decoration-none d-block mt-2 text-center text-primary"
            @click="activeTab = activeTab === 'about' ? 'posts' : 'about'">
            {{ activeTab === 'about' ? 'See less' : 'See more' }}
            <i class="bi" :class="activeTab === 'about' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </a>
          </div>

        </div>

      </div>
      <div class="tab-content col-lg-6 col-md-12 col-12 flex-grow-1" id="personal_profile_tabs_content">
        <div class="tab-pane fade" :class="{ 'show active': activeTab === 'about' }" id="about" role="tabpanel"
          aria-labelledby="about_tab">
           <div class="p-4 bg-white rounded shadow-sm border">

          <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="fw-bold text-secondary mb-0 d-flex align-items-center">
              <i class="bi bi-person-fill me-2"></i>Profile Information
            </h5>

            <button
              v-if="isOwner"
              type="button"
              class="btn btn-primary btn-sm text-xxs ms-auto rounded"
              data-bs-toggle="modal"
              data-bs-target="#profile_modal"
              title="Edit Profile"
            >
              <i class='bx bxs-edit-alt text-xxs'></i> Edit Profile
            </button>
          </div>

      <div class="">

  <!-- Info Item -->
          <div class="row" v-if="can_show_profile_field('show_email', profileData.email)">
        <div class="bg-light rounded p-1 my-1 border ">
          <div class="row">
            <div class="col-md-6 text-primary text-xxs">
              <i class='bx bxs-envelope fs-6 mx-2 text-primary'></i><strong>Email:</strong>
            </div>
            <div class="col-md-6">
              <p class="mx-2 text-xxs text-end text-md-start">

        {{ profileData.email || '' }}
        <span v-if="isOwner">
          <i v-if="isValidField(profileData.email)"
            :class="[
              profileData.visibility?.show_email === true
                ? 'bi bi-globe'
                : 'bi bi-lock-fill text-muted',
              'ms-2 cursor-pointer'
            ]"
            @click="open_visibility_modal('show_email')"></i>
        </span>
        <span v-else-if="profileData.visibility?.show_email !== true">
          <i v-if="isValidField(profileData.email)" class="bi bi-lock-fill text-muted"></i>
        </span>

              </p>
      </div>
          </div>
        </div>
          </div>

        <!-- Phone -->
         <div class="row" v-if="can_show_profile_field('show_phone_number', profileData.phone_number)">
  <!-- your phone row content -->
        <div class="bg-light rounded p-1 my-1 border">

          <div class="row">
            <div class="col-md-6 text-primary text-xxs">
              <i class='bx bxs-phone-call fs-5 mx-2 text-primary'></i><strong>Phone:</strong>
            </div>
            <div class="col-md-6">
              <p class="mx-2 text-xxs text-end text-md-start">
            {{ profileData.phone_number || '' }}
            <span v-if="isOwner">
              <i v-if="isValidField(profileData.phone_number)"  :class="[profileData.visibility?.show_phone_number === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                @click="open_visibility_modal('show_phone_number')"></i>
            </span>
            <span v-else-if="profileData.visibility?.show_phone_number !== true">
              <i v-if="isValidField(profileData.phone_number)" class="bi bi-lock-fill text-muted"></i>
            </span>
            </p>
          </div>
          </div>
        </div>
         </div>

        <!-- Date of Birth -->
         <div class="row" v-if="can_show_profile_field('show_date_of_birth', profileData.date_of_birth)">
        <div class="bg-light rounded p-1 my-1 border">
          <div class="row">
            <div class="col-md-6 text-primary text-xxs">
              <i class='bx bxs-calendar fs-5 mx-2 text-primary'></i><strong>Date of Birth:</strong>
            </div>
            <div class="col-md-6">
              <p class="mx-2 text-xxs text-end text-md-start">


            {{ is_valid_value(profileData.date_of_birth) ? profileData.date_of_birth : '' }}
            <span v-if="isOwner">
              <i v-if="isValidField(profileData.date_of_birth)" :class="[profileData.visibility?.show_date_of_birth === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                @click="open_visibility_modal('show_date_of_birth')"></i>
            </span>
            <span v-else-if="profileData.visibility?.show_date_of_birth !== true">
              <i v-if="isValidField(profileData.date_of_birth)" class="bi bi-lock-fill text-muted"></i>
            </span>
                </p>
</div>
          </div>
        </div>
        </div>

        <!-- Address -->
         <div class="row" v-if="can_show_profile_location()">
        <div class="bg-light rounded p-1 my-1 border">
          <div class="row">
            <div class="col-md-6 text-primary text-xxs">
              <i class='bx bxs-map fs-5 mx-2 text-primary'></i><strong>Address:</strong>
            </div>
            <div class="col-md-6">
              <p class="mx-2 text-xxs text-end text-md-start">
              {{ is_valid_value(profileData.location) ? profileData.location : '' }}
                                <span v-if="profileData.province && profileData.postal_code">, </span>
                                {{ is_valid_value(profileData.province) ? profileData.province : '' }}
                            <span v-if="isOwner">
                              <i v-if="isValidField(profileData.location)":class="[profileData.visibility?.show_location === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                                @click="open_visibility_modal('show_location')"></i>
                            </span>
                            <span v-else-if="profileData.visibility?.show_location !== true">
                              <i v-if="isValidField(profileData.show_location)" class="bi bi-lock-fill text-muted"></i>
                            </span>
              </p>

            </div>
          </div>
        </div>
        </div>

        <!-- Title & Gender -->
         <div class="row" v-if="can_show_profile_field('show_title', profileData.title)">
        <div class="bg-light rounded p-1 my-1 border">
          <!-- Title Row -->
          <div class="row">
            <div class="col-md-6 text-primary text-xxs">
              <i class='bx bx-id-card fs-5 mx-2 text-primary'></i><strong>Title:</strong>
            </div>
            <div class="col-md-6">
              <p class="mx-2 text-xxs text-end text-md-start">
                {{ profileData.title || '' }}
              <span v-if="isOwner">
                <i v-if="isValidField(profileData.title)" :class="[profileData.visibility?.show_title === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                  @click="open_visibility_modal('show_title')"></i>
              </span>
              <span v-else-if="profileData.visibility?.show_title !== true">
                <i v-if="isValidField(profileData.title)" class="bi bi-lock-fill text-muted"></i>
              </span>
              </p>

            </div>
          </div>
          </div>
         </div>
          <div class="row" v-if="can_show_profile_field('show_gender', profileData.gender)">
        <div class="bg-light rounded p-1 my-1 border">

          <!-- Gender Row -->
          <div class="row">
            <div class="col-md-6 text-primary text-xxs">
              <i class='bx bx-id-card fs-5 mx-2 text-primary'></i><strong>Gender:</strong>
            </div>
            <div class="col-md-6">
              <p class="mx-2 text-xxs text-end text-md-start">{{ profileData.gender || '' }}
              <span v-if="isOwner">
                <i v-if="isValidField(profileData.gender)" :class="[profileData.visibility?.show_gender === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'ms-2 cursor-pointer']"
                  @click="open_visibility_modal('show_gender')"></i>
              </span>
              <span v-else-if="profileData.visibility?.show_gender !== true">
                <i v-if="isValidField(profileData.gender)" class="bi bi-lock-fill text-muted"></i>
              </span>
              </p>
            </div>
          </div>
        </div>
        </div>

        <!-- Race -->
         <div class="row" v-if="can_show_profile_field('show_race', profileData.race)">
        <div class="bg-light rounded p-2 border my-1">
          <div class="row">
            <div class="col-md-6 col-md-4 text-primary text-xxs">
              <i class='bx bx-group fs-5 mx-2 text-primary'></i><strong>Race:</strong>
            </div>
            <div class="col-md-6">
              <p class="mx-2 text-xxs text-end text-md-start
">{{ profileData.race || '' }} <span v-if="isOwner">
                <i v-if="isValidField(profileData.race)" :class="[profileData.visibility?.show_race === true ? 'bi bi-globe' : 'bi bi-lock-fill text-muted', 'mx-2 cursor-pointer']"
                  @click="open_visibility_modal('show_race')"></i>
              </span>
              <span v-else-if="profileData.visibility?.show_race !== true" class="mx-2 text-xxs">
                <i v-if="isValidField(profileData.race)" class="bi bi-lock-fill text-muted"></i>
              </span>
            </p>

            </div>
          </div>
        </div>
        </div>


          
      <div v-for="section in all_section" class="row">

        <!-- SECTION QUESTIONS EXIST -->
        <div v-if="section.section?.question_sections?.length" class="p-0">

          <!-- LOOP QUESTIONS -->
          <div
            v-for="(qa, index) in filteredQuestionSections(section)"
            :key="'qa_' + qa.id"
            class="bg-light rounded p-1 border my-1"
          >

            <!-- ===========================
                COMPACT QUESTION ROW
            ============================ -->
            <div class="row align-items-center">

              <!-- ========================================
                  LEFT SIDE — QUESTION TEXT + ICONS
              ========================================= -->
              <div class="col-md-4 text-primary d-flex align-items-center">

                <!-- Question Icon -->
                <i class="bi bi-question-circle-fill fs-6 me-2 text-primary"></i>

                <!-- Question Text -->
                <strong class="mb-0 text-xxs">
                  {{ qa.question?.question || "Untitled Question" }}
                </strong>

                <!-- Visibility Toggle -->
                <i
                  v-if="isOwner &&
                        !qa.question?.is_mandatory &&
                        getAnswerByQuestionId(qa.question.id)?.answer"
                  :class="[
                    qa.question.is_mandatory ||
                    (getAnswerByQuestionId(qa.question.id)?.is_visible ?? true)
                      ? 'bi bi-globe'
                      : 'bi bi-lock-fill text-muted',
                    'ms-2 cursor-pointer'
                  ]"
                  title="Toggle visibility"
                  @click="open_answer_visibility_modal(getAnswerByQuestionId(qa.question.id))"
                ></i>
              </div>

              <!-- ========================================
                  RIGHT SIDE — ANSWERS / INPUTS
              ========================================= -->
              <div class="col-md-8 d-flex justify-content-end text-dark">

                <!-- =======================
                    CREATOR MODE (Editable)
                ======================== -->
                <div v-if="isOwner" class="w-75 text-end">

                  <!-- TEXT -->
                  <input
                    v-if="qa.question.question_type?.question_type === 'text'"
                    v-model="qa.newAnswer"
                    type="text"
                    class="form-control form-control-sm rounded w-100 mb-2 ms-auto"
                    @input="qa.isChanged = true"
                  />

                  <!-- LINK -->
                  <input
                    v-else-if="qa.question.question_type?.question_type === 'link'"
                    v-model="qa.newAnswer"
                    type="url"
                    class="form-control form-control-sm rounded w-100 mb-2 ms-auto"
                    placeholder="Enter a valid URL (e.g. https://example.com)"
                    @input="qa.isChanged = true"
                  />

                  <!-- TEXTAREA -->
                  <textarea
                    v-else-if="qa.question.question_type?.question_type === 'textarea'"
                    v-model="qa.newAnswer"
                    class="form-control form-control-sm rounded w-100 mb-2 ms-auto"
                    placeholder="Enter your answer (max 500 words)"
                    @input="handleTextareaInput(qa)"
                  ></textarea>

                  <!-- DATE -->
                  <input
                    v-else-if="qa.question.question_type?.question_type === 'date'"
                    v-model="qa.newAnswer"
                    type="date"
                    class="form-control form-control-sm rounded w-50 mb-2 ms-auto text-end"
                    @input="qa.isChanged = true"
                  />

                  <!-- NUMBER -->
                  <input
                    v-else-if="qa.question.question_type?.question_type === 'number'"
                    v-model="qa.newAnswer"
                    type="number"
                    class="form-control form-control-sm rounded w-50 mb-2 ms-auto text-end"
                    @input="qa.isChanged = true"
                  />

                  <!-- SELECTION DROPDOWN -->
                  <select
                    v-else-if="qa.question.question_type?.question_type === 'selection'"
                    v-model="qa.newAnswer"
                    class="form-control form-control-sm rounded w-100 mb-2 ms-auto"
                    @change="qa.isChanged = true"
                  >
                    <option
                      v-for="opt in extendedOptions(qa)"
                      :key="opt.id || 'custom'"
                      :value="opt.option"
                    >
                      {{ opt.option }}
                    </option>
                  </select>

                  <!-- OTHER INPUT -->
                  <input
                    v-if="
                      String(qa.newAnswer) &&
                      /^others?( \(?please specify\)?)?$/i.test(String(qa.newAnswer).trim())
                    "
                    v-model="qa.customAnswer"
                    placeholder="Please specify"
                    class="form-control form-control-sm rounded w-100 mb-2 ms-auto"
                    @input="qa.isChanged = true"
                  />

                  <!-- MULTIPLE CHOICE -->
                  <div
                    v-else-if="qa.question.question_type?.question_type === 'multiple_choice'"
                    class="text-end mb-2"
                  >
                    <div
                      v-for="opt in extendedOptions(qa)"
                      :key="opt.id || 'custom'"
                      class="form-check d-flex justify-content-end"
                    >
                      <label class="form-check-label text-xxs me-2">
                        {{ opt.option }}
                      </label>

                      <input
                        class="form-check-input"
                        type="radio"
                        :value="opt.option"
                        v-model="qa.newAnswer"
                        @change="qa.isChanged = true"
                      />
                    </div>

                    <input
                      v-if="String(qa.newAnswer).toLowerCase().trim() === 'other'"
                      v-model="qa.customAnswer"
                      class="form-control form-control-sm rounded w-100 mt-2 ms-auto"
                      placeholder="Please specify"
                      @input="qa.isChanged = true"
                    />
                  </div>

                  <!-- CHECKBOX -->
                  <div
                    v-else-if="qa.question.question_type?.question_type === 'checkbox'"
                    class="d-flex flex-column text-end"
                  >
                    <div
                      v-for="opt in qa.question.options"
                      :key="opt.id"
                      class="form-check d-flex justify-content-end mb-1"
                    >
                      <label class="form-check-label text-xxs me-5">
                        {{ opt.option }}
                      </label>

                      <input
                        type="checkbox"
                        class="form-check-input"
                        :value="opt.option"
                        :checked="qa.newAnswer?.includes(opt.option)"
                        @change="toggleCheckbox(qa, opt.option, $event.target.checked); qa.isChanged = true"
                      />
                    </div>
                  </div>

                  <!-- FILE -->
                  <div
                    v-else-if="qa.question.question_type?.question_type === 'file'"
                    class="d-flex flex-column align-items-end text-end"
                  >
                    <input
                      type="file"
                      class="d-none"
                      :ref="`fileInput_${qa.question.id}`"
                      @change="onFileSelect(qa, $event)"
                    />

                    <input
                      type="text"
                      class="form-control form-control-sm rounded w-100 mb-2 ms-auto cursor-pointer"
                      :value="
                        qa.newFile
                          ? qa.newFile.name
                          : qa.files?.length
                          ? qa.files[0].file.name
                          : ''
                      "
                      placeholder="No file chosen"
                      readonly
                      @click="triggerFileInput(qa)"
                    />

                    <button
                      v-if="qa.files?.length"
                      class="btn btn-secondary btn-sm rounded shadow-sm"
                      @click="
                        open_file_answer_viewer(
                          qa.files[0].file.s3_url,
                          qa.files[0].file.name
                        )
                      "
                    >
                      View
                    </button>
                  </div>

                  <!-- ERRORS -->
                  <div
                    v-if="qa.validation_error"
                    class="text-danger text-end small mt-1"
                  >
                    <i class="bi bi-exclamation-circle-fill me-1"></i>
                    {{ qa.validation_error }}
                  </div>
                </div>

                <!-- =======================
                    NON OWNER — VIEW MODE
                ======================== -->
                <div v-else class="w-75 text-end">

                  <!-- CHECKBOX -->
                  <div
                    v-if="qa.question.question_type?.question_type === 'checkbox'"
                  >
                    <div
                      v-if="
                        profileData.answers &&
                        profileData.answers.find(ans => ans.question.id === qa.question.id)?.answer?.trim() !== ''
                      "
                    >
                      <div
                        v-for="val in profileData.answers.find(ans => ans.question.id === qa.question.id).answer.split(',')"
                        :key="val.trim()"
                        class="form-check d-flex justify-content-end mb-1"
                      >
                        <label class="form-check-label me-2">
                          {{
                            getOptionValue(val.trim(), qa.question.options) || val.trim()
                          }}
                        </label>
                        <input type="checkbox" checked readonly class="form-check-input" />
                      </div>
                    </div>
                  </div>

                  <!-- LINK -->
                  <div v-else-if="qa.question.question_type?.question_type === 'link'">
                    <a
                      :href="profileData.answers.find(ans => ans.question.id === qa.question.id).answer"
                      target="_blank"
                      class="text-primary text-decoration-underline"
                    >
                      {{ profileData.answers.find(ans => ans.question.id === qa.question.id).answer }}
                    </a>
                  </div>

                  <!-- FILE -->
                  <div v-else-if="qa.question.question_type?.question_type === 'file'">
                    <div
                      v-if="profileData.answers.find(ans => ans.question.id === qa.question.id)?.files?.length"
                      class="d-flex justify-content-end align-items-center gap-2"
                    >
                      <span>
                        {{
                          profileData.answers.find(ans => ans.question.id === qa.question.id).files[0].file.name
                        }}
                      </span>

                      <button
                        class="btn btn-secondary btn-sm rounded shadow-sm"
                        @click="
                          open_file_answer_viewer(
                            profileData.answers.find(ans => ans.question.id === qa.question.id).files[0].file.s3_url,
                            profileData.answers.find(ans => ans.question.id === qa.question.id).files[0].file.name
                          )
                        "
                      >
                        View
                      </button>
                    </div>

                    <div v-else class="text-muted fst-italic text-end">
                      No file uploaded
                    </div>
                  </div>

                  <!-- DEFAULT ANSWER -->
                  <div v-else>
                    {{
                      profileData.answers.find(ans => ans.question.id === qa.question.id)?.answer || ""
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- PAGINATION (unchanged) -->
        <div
          v-if="
            total_puestion_pages(
              section.section.question_sections.filter(q => isOwner || has_answer_for_question(q))
            ) > 1
          "
          aria-label="Questions pagination"
          class="mt-3 d-none"
        >
          <ul class="pagination justify-content-center">
            <li class="page-item me-1" :class="{ disabled: question_page === 1 }">
              <button
                class="page-link bg-primary text-xxs rounded btn-sm mt-2 text-white"
                @click="change_question_page(question_page - 1, section)"
                :disabled="question_page === 1"
              >
                Previous
              </button>
            </li>

            <li
              class="page-item me-1"
              v-for="page in total_puestion_pages(
                section.section.question_sections.filter(q => isOwner || has_answer_for_question(q))
              )"
              :key="page"
              :class="{ active: question_page === page }"
            >
              <button
                class="page-link text-xxs rounded btn-sm mt-2"
                @click="change_question_page(page, section)"
                :class="{
                  'bg-secondary text-white': question_page === page,
                  'text-primary': question_page !== page
                }"
              >
                {{ page }}
              </button>
            </li>

            <li
              class="page-item ms-1"
              v-if="
                question_page <
                total_puestion_pages(
                  section.section.question_sections.filter(q => isOwner || has_answer_for_question(q))
                )
              "
            >
              <button
                class="page-link bg-primary text-xxs rounded btn-sm mt-2 text-white"
                @click="handle_next_page(section)"
              >
                Next
              </button>
            </li>
          </ul>
        </div>

      </div>


  </div>
    <div v-if="isOwner && all_section.some(s => s.section?.question_sections?.some(q => q.isChanged))"
      class="d-flex justify-content-end mt-3"
    >
    <button class="btn btn-primary rounded shadow btn-sm" :disabled="isSubmitting"
        @click="submit_all_answers"
      >
        <span  v-if="isSubmitting" class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true" ></span>
        Save
      </button>
    </div>
          </div>
        </div>
        <div class="tab-pane fade":class="{ 'show active': activeTab === 'posts' }" id="posts" role="tabpanel" aria-labelledby="posts_tab">
            <div class="row justify-content-center">

              <div>
                <div v-if="String(profileData?.base_profile?.creater?.id) === String(user_details.user_id)">

                  <CreateFeed @new_report="addReportToHome"
                    :activeProfile="active_profile_data" :profileName="(profileData.base_profile?.creater?.first_name +' '+ profileData.base_profile?.creater?.last_name)" />
                </div>
                <!-- Posts Section -->
                <div
                  class=" post-section mt-2  h-150 full-width-mobile overflow-auto scrollable-container padding-x">

                  <div class="d-flex align-items-center temporary-post" v-if="temporaryPost" id="temp-post">
                    <p class="text-xxs fw-bold">{{ temporaryPost.report_name }} - Posting...</p>
                    <div class="spinner-border ms-auto  text-secondary" role="status" aria-hidden="true"></div>
                  </div>
                  <div v-if="reports.length === 0 && is_loading" class="text-center py-5 w-100">
                    <div class="spinner-border text-secondary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2 mb-0 text-muted">Loading feeds...</p>
                  </div>

                  <div v-else>
                    <!-- Scrollable container -->
                    <div v-if="reports.length > 0">

                      <div v-for="report in reports" :key="report.id" :id="'post-' + report.id"
                        class=" card card-hover mb-4 p-3 d-flex flex-column border-bottom rounded-5 border-0 full-width-mobile shadow report-card">
                        <div class="row">
                          <div class="col p-3">
                            <div class="d-flex align-items-start gap-3">
                              <img v-if="!dwypd_domain"
                                :src="report.base_profile?.profile_type === 'personal'
                                      ? (report.base_profile?.user?.profile?.profile_files?.[0]?.file?.url || require('@/assets/images/user.png'))
                                      : (report.base_profile?.company?.base_profile?.profile_files?.[0]?.file?.file_url || require('@/assets/images/user.png'))"
                                loading="lazy"
                                class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0" />

                              <div class="flex-grow-1">
                                <div class="d-flex justify-content-between align-items-start">
                                  <div class="pe-2">
                                    <!-- Name / Company + topic + pin -->
                                    <p v-if="!dwypd_domain" class="fw-500 mb-1 lh-base small">
                                      <span v-if="report?.base_profile?.user?.is_blocked">
                                        Unknown User
                                      </span>
                                      <span
                                        v-else-if="report?.base_profile?.profile_type?.toLowerCase().trim() === 'personal'"
                                        @click="view_profile(report.base_profile?.user?.id)">
                                        {{ report.base_profile?.user?.first_name }} {{
                                        report.base_profile?.user?.last_name }}
                                      </span>
                                      <span v-else @click="view_company(report)">
                                        {{ report.base_profile?.company?.company_name || 'Company Name' }}
                                      </span>

                                      <span v-if="report.topic?.name" class="badge bg-warning text-dark ms-2 align-middle">
                                        <i class="bx bxs-bulb me-1"></i>{{ report.topic?.name }}
                                      </span>

                                      <span v-if="report.is_pinned" class="ms-2 text-warning align-middle">
                                        <i class="bx bxs-pin"></i>
                                      </span>
                                    </p>

                                    <!-- Date -->
                                    <p v-if="!dwypd_domain"
                                      class="text-muted small mb-0 d-flex align-items-center gap-1">
                                      <i class="bx bxs-stopwatch"></i>
                                      <span>{{ report.publication_date }}</span>
                                    </p>
                                  </div>

                                  <!-- Three Dots Menu -->
                                  <div class="dropstart ms-2" @click.stop
                                    v-if="(String(report.base_profile?.user?.id) === String(user_details.user_id) && token_exists) || user_details.user_role === 'admin'">
                                    <a href="" class="text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                      aria-expanded="false">
                                      <i class="bi bi-three-dots-vertical"></i>
                                    </a>
                                    <ul class="dropdown-menu dropdown-menu-end lh-sm"
                                      aria-labelledby="dropdownMenuButton">
                                      <a v-if="user_details.user_role === 'admin'"
                                        class="dropdown-item small fw-bold border-bottom d-none" href=""
                                        @click.prevent="togglePinReport(report)">
                                        <i :class="report.is_pinned ? 'bx bx-pin fs-6' : 'bx bxs-pin fs-6'"></i>
                                        {{ report.is_pinned ? 'Unpin' : 'Pin' }}
                                      </a>
                                      <li
                                        v-if="(soulcity_domain && user_details.user_role === 'admin') || String(report.base_profile?.user?.id) === String(user_details.user_id)">
                                        <a class="dropdown-item small fw-bold" href="" data-bs-toggle="modal"
                                          data-bs-target="#edit_report_modal" @click="edit_report(report)"
                                          v-if="report.total_comments === 0 && report.total_likes === 0">
                                          <i class="bx bxs-edit fs-6"></i> Edit
                                        </a>
                                      </li>
                                      <li>
                                        <a class="dropdown-item small fw-bold d-none" href=""
                                          @click.prevent="open_event_modal(report.id)">
                                          <i class="bi bi-calendar-event fs-6"></i> Add Event
                                        </a>
                                      </li>
                                      <li>
                                        <a class="dropdown-item small fw-bold" href=""
                                          @click.prevent="deleteReport(report.id)">
                                          <i class="bx bxs-trash-alt fs-6"></i> Delete
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>


                            <!-- Report Description -->
                            <p class="fw-500 text-xxs mt-2 " v-if="report.name">{{ report.name }}</p>
                            <div class="quill-wrapper">
                              <div v-html="displayedDescription(report)" :class="['ql-editor quill-content','fs-6','lh-lg']">
                              </div>
                            </div>

                            <!-- Images -->
                            <!-- ✅ IMAGE FILES -->
                            <div v-if="getCarouselImages(report).length" class="business-carousel">
                              <div :id="'carousel-' + report.id" class="carousel slide">
                                <!-- Indicators -->
                                <div v-if="getCarouselImages(report).length>1" class="carousel-indicators">
                                  <button v-for="(src, i) in getCarouselImages(report)" :key="'indicator-' + i"
                                    type="button" :data-bs-target="'#carousel-' + report.id" :data-bs-slide-to="i"
                                    :class="{ active: i === 0 }" aria-current="i === 0 ? 'true' : undefined"
                                    :aria-label="'Slide ' + (i + 1)"></button>
                                </div>

                                <!-- Carousel Inner -->
                                <div class="carousel-inner">
                                  <div v-for="(src, i) in getCarouselImages(report)" :key="'carousel-img-' + i"
                                    :class="['carousel-item', { active: i === 0 }]">
                                    <img :src="src.file.url" alt="Feed Image" class="carousel-img media-item rounded-5"
                                      @click="display_comment_modal(report)" />
                                  </div>
                                </div>

                                <!-- Controls -->
                                <div v-if="getCarouselImages(report).length>1">
                                  <button class="carousel-control-prev" type="button"
                                    :data-bs-target="'#carousel-' + report.id" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                  </button>
                                  <button class="carousel-control-next" type="button"
                                    :data-bs-target="'#carousel-' + report.id" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex flex-column" v-if="report.report_files && report.report_files.length">
                              <div v-for="(fileObj, index) in report.report_files" :key="index" class="mb-3">

                                <!-- ✅ IMAGE FILES -->
                                <div class="media-container image-only mb-3" v-if="fileObj?.file?.url &&
                                  (fileObj.file.url.includes('.jpg') ||
                                  fileObj.file.url.includes('.JPG') ||
                                  fileObj.file.url.includes('.png') ||
                                  fileObj.file.url.includes('.PNG') ||
                                  fileObj.file.url.includes('.avif') ||
                                  fileObj.file.url.includes('.AVIF') ||
                                  fileObj.file.url.includes('.jpeg') ||
                                  fileObj.file.url.includes('.JPEG') ||
                                  fileObj.file.url.includes('.webp') ||
                                  fileObj.file.url.includes('.WEBP'))">
                                  <!-- <img :src="fileObj.file.url" alt="Feed Image" class="media-item rounded-5"
                                  @click="display_comment_modal(report)" /> -->
                                </div>

                                <!-- ✅ AUDIO FILES -->
                                <div class="media-container video-audio mb-3" v-else-if="fileObj?.file?.url &&
                                      (fileObj.file.url.includes('.mp3') ||
                                        fileObj.file.url.includes('.wav'))">
                                  <audio controls class="rounded-3 p-1">
                                    <source :src="fileObj.file.url"
                                      :type="fileObj.file.url.includes('.mp3') ? 'audio/mpeg' : 'audio/wav'" />
                                    Your browser does not support the audio element.
                                  </audio>
                                </div>

                                <!-- ✅ VIDEO FILES -->
                                <div class="media-container video-audio mb-3"
                                  v-else-if="fileObj?.file?.url && /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)">
                                  <video controls class="media-item rounded-5" @click="display_comment_modal(report)">
                                    <source :src="fileObj.file.url" />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>

                                <!-- ✅ OTHER FILES (PDF, DOCX, ZIP, ETC.) -->
                                <!-- ✅ OTHER FILES (PDF, DOCX, ZIP, ETC.) -->
                                <div v-else
                                class="uploaded-file d-flex align-items-center justify-content-between p-3 mb-2 rounded shadow-sm"
                                @click="open_preview(fileObj)">
                                <!-- File Info -->
                                <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                                  <div class="d-flex align-items-center justify-center me-3 flex-shrink-0">
                                    <img
                                      v-if="fileObj?.file?.url"
                                      :src="getFileIcon(fileObj.file.url)"
                                      class="file-icon"/>
                                  </div>
        
                                  <div class="file-details">
                                    <span class="file-name d-block">
                                      {{ getFileName(fileObj?.file?.url) }}
                                    </span>
                                  </div>
                                </div>
                                <!-- Actions -->
                                <div class="d-flex align-items-center gap-3 flex-shrink-0 ms-3">
                                  <a
                                    :href="fileObj?.file?.url"
                                    download
                                    :title="getFileName(fileObj?.file?.url)"
                                    class="file-action-btn"
                                    @click.stop
                                  >
                                    <i class="bi bi-download"></i>
                                  </a>
        
                                  <a
                                    @click.stop="toggle_library_save(fileObj)"
                                    class="file-action-btn"
                                    :title="isInLibrary(fileObj?.file.id) ? 'Remove from Library' : 'Save to Library'"
                                  >
                                    <i
                                      class="bi"
                                      :class="isInLibrary(fileObj?.file.id)
                                        ? 'bi-bookmark-check-fill text-dark'
                                        : 'bi-bookmark text-muted'"
                                    ></i>
                                  </a>
                                </div>
                              </div>

                                      </div>
                                    </div>


                            <div v-if="report.linkPreview"
                              class="link-preview rounded mt-2 p-2 position-relative border">

                              <a :href="report.report_link" target="_blank" class="text-decoration-none">
                                <img v-if="report.linkPreview.image" :src="report.linkPreview.image"
                                  class="img-fluid rounded" />
                                <div class="fw-bold mt-2">{{ report.linkPreview.title }}</div>
                                <div v-if="!report.linkPreview.image" class="text-muted small">{{
                                  report.linkPreview.description
                                  }}</div>
                              </a>
                            </div>
                            <!-- ✅ Event Display -->
                            <div
                              v-if="report.event_report && report.event_report.length && report.event_report[0].event.end_date >= currentDate"
                              class="mt-3">
                              <div v-for="event in [report.event_report[0].event]" :key="event.id || 'event-report-0'"
                                class="card border rounded-5 shadow-sm mb-4 mt-3" @click.stop>
                                <div class="card-body">
                                  <div class="d-flex justify-content-between align-items-start">
                                    <div class="flex-grow-1 pe-3">
                                      <div class="d-flex flex-wrap">
                                        <p class="fw-semibold ms-3">Event : {{ event.event_name }}</p>

                                      </div>
                                    </div>
                                  </div>
                                  <hr class="my-0">
                                  <div class="row g-4 mb-4">
                                    <!-- Event Period -->
                                    <div class="col-12 col-md-4">
                                      <div class="d-flex gap-3">
                                        <div
                                          class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                                          <i class="bi bi-calendar-event fs-5 text-secondary"></i>
                                        </div>
                                        <div class="flex-grow-1">
                                          <div class="text-uppercase text-muted small fw-semibold mb-1">Event Period
                                          </div>
                                          <div class="fw-semibold text-xxs">{{event.start_date }}</div>
                                          <div class="text-muted text-xxs">{{ event.start_time ? event.start_time : ''
                                            }}
                                            <span v-if="event.end_time"> to {{ event.end_time }}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-12 col-md-4">
                                      <div class="d-flex gap-3">
                                        <div
                                          class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                                          <i class="bi bi-geo-alt fs-5 text-secondary"></i>
                                        </div>
                                        <div class="flex-grow-1">
                                          <div class="text-uppercase text-muted text-xxs fw-semibold mb-1">Location
                                          </div>
                                          <div class="fw-semibold text-xxs">{{ event.location || 'Not set' }}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Actions -->
                                  <div class="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                                    <button v-if="event.is_free"
                                      class="btn btn-primary btn-sm rounded px-3 py-1 shadow text-xxs"
                                      @click.stop="openModal(event)">
                                      <i class="bi bi-check-circle me-1"></i> RSVP
                                    </button>

                                    <button v-else class="btn btn-primary btn-sm rounded px-3 py-1 shadow text-xxs"
                                      @click.stop="openModal(event)">
                                      <i class="bi bi-ticket-perforated me-1"></i> Buy Ticket
                                    </button>
                                    <a href="/view_events" class="btn btn-primary btn-sm rounded px-3 py-1 text-xxs">

                                      View Event
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-if="dwypd_domain && report && report.authors && report.authors.length"
                              class="me-5 py-1 rounded bg-light d-inline-flex align-items-start flex-wrap gap-2">
                              <span class="fw-bold text-primary me-2">Authors:</span>
                              <span v-for="(author, index) in report.authors" :key="index"
                                class="badge bg-primary text-white d-inline-flex align-items-center gap-1 mt-1">

                                <a v-if="author.author_link" :href="author.author_link" target="_blank"
                                  class="text-white" @click.stop>
                                  {{ author.author_name }}
                                </a>
                                <span v-else>{{ author.author_name }}</span>

                              </span>
                            </div>


                            <!-- Likes and Comments Count -->
                            <div class="text-gray mx-2 mt-1 text-end pointer">
                              <span class="me-2" @click="open_likes_modal(report.likes)" data-bs-toggle="modal"
                                data-bs-target="#likes_modal">
                                {{ report.total_likes }}
                                <img src="@/assets/images/like (1).png" class="mb-2 pointer" width="16" height="16"
                                  alt="">
                              </span>
                              <span>{{ report.total_comments }}
                                <img src="@/assets/images/speech-bubble.png" class="pointer" alt="" width="16"
                                  height="16">
                              </span>
                            </div>

                            <!-- Action Buttons -->
                            <div
                              class="d-flex justify-content-between align-items-center border-top border-bottom px-2 py-1 mb-2">
                              <div class="d-flex align-items-center me-3">
                                <!-- Like button -->
                                <span v-if="!likedReports[report.id]" class="d-flex align-items-center fw-500 pointer"
                                  @click.stop="likeReport(report)">
                                  <img src="@/assets/images/like.png" alt="" width="20" height="20" class="pointer">
                                  <span class="text-purple text-xxs mx-1">Like</span>
                                </span>

                                <!-- Unlike button -->
                                <span v-else class="d-flex align-items-center fw-500 pointer"
                                  @click.stop="unlikeReport(report)">
                                  <img src="@/assets/images/like (1).png" alt="" width="20" height="20" class="pointer">
                                  <span class="text-xxs mx-1">Unlike</span>
                                </span>

                              </div>
                              <div
                                :class="`d-flex align-items-center me-3  ${!report.can_comment ? 'comment-disabled' : 'pointer'}`"
                                @click="active_comment_report_id = report.id">
                                <img src="@/assets/images/speech-bubble.png" alt="" width="20" height="20"
                                  class="pointer">
                                <span class="fw-500 text-xxs mx-1">Comment</span>
                              </div>
                              <!-- Share Menu -->
                              <div class="d-flex align-items-center me-2 menu mt-1 bg-white text-xxs" @click.stop>
                                <input type="checkbox" :id="'menu-open-' + report.id" class="menu-open"
                                  name="menu-open" />
                                <label :for="'menu-open-' + report.id"
                                  class="menu-open-button d-flex align-items-center" @click="boon">
                                  <img src="@/assets/images/share (1).png" width="20" height="20" alt=""
                                    class="pointer">
                                  <span class="mx-1 fw-500 t">Share</span>
                                </label>

                                <!-- Copy Link -->
                                <a @click="copy_report_link_to_clipboard(report)" class="menu-item bg-white  shadow-sm">
                                  <span @click="closeMenu(report.id)">
                                    <i class="bi bi-link fs-4 copy text-primary text-xxs"></i>
                                  </span>
                                </a>

                                <!-- Twitter -->
                                <a :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(baseUrl(report,'report'))"
                                  target="_blank" class="menu-item bg-white  shadow-sm" @click="closeMenu(report.id)">
                                  <i class="bi bi-twitter-x"></i>
                                </a>

                                <!-- LinkedIn -->
                                <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(baseUrl(report,'report'))"
                                  target="_blank" class="menu-item bg-white  shadow-sm linkedin-share-btn"
                                  @click="closeMenu(report.id)">
                                  <i class="bi bi-linkedin"></i>
                                </a>

                                <!-- Facebook -->
                                <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl(report,'report'))"
                                  target="_blank" class="menu-item bg-white  shadow-sm facebook-share-btn"
                                  @click="closeMenu(report.id)">
                                  <i class="bi bi-facebook"></i>
                                </a>

                                <!-- WhatsApp -->
                                <a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(baseUrl(report,'report'))"
                                  target="_blank" class="menu-item bg-white  shadow-sm whatsapp-share-btn"
                                  @click="closeMenu(report.id)">
                                  <i class="bi bi-whatsapp"></i>
                                </a>

                                <!-- Copy Toast -->
                                <!-- <div aria-live="polite" aria-atomic="true"
                                  class="position-fixed top-0 start-50 translate-middle-x p-3"
                                  style="z-index: 1080;">
                              <div id="copyToast" class="toast bg-primary border-0 text-white" role="alert"
                                aria-live="assertive" aria-atomic="true">
                                <div class="d-flex">
                                  <div class="toast-body"></div>
                                  <button type="button" class="btn-close btn-close-white me-2 m-auto"
                                    data-bs-dismiss="toast" aria-label="Close"></button>
                                </div>
                              </div>
                            </div> -->

                              </div>

                            </div>


                            <div class="d-flex align-items-center border rounded-pill mb-3 p-0"
                              v-if="active_comment_report_id === report.id">
                              <img src="@/assets/images/user.png" alt="User" class="rounded-circle mx-2" width="32"
                                height="32">
                              <input type="text" class="form-control border-0 rounded-5" id="comment_text_area"
                                v-model="commentText" placeholder="Write a comment" aria-label="Recipient's username"
                                aria-describedby="button-addon2">
                              <div class="d-flex align-items-center">
                                <button class="btn btn-sm text-xxs" type="button" id="button-addon2"
                                  @click="submit_comment(report.id)"><i class="bi bi-send fs-5"></i></button>
                              </div>
                            </div>
                            <!-- Comments Component -->
                            <Comments :comments="report.comments" :report-id="report.id"
                              @add-comment="handleAddComment" />

                          </div>
                        </div>
                      </div>
                      <div v-if="is_loading" class="text-center py-3">
                        <div class="spinner-border text-secondary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="mt-2 mb-0 text-muted">Loading...</p>
                      </div>


                    </div>

                    <div v-else class="text-center py-3">
                      <p class="mt-2 mb-0 text-muted">No reports found.</p>
                    </div>


                  </div>
                </div>
              </div>
            </div>

          </div>

    </div>

    <div class="col-lg-3 d-none d-lg-block">
      <div class="bg-transparent p-2 rounded animate-up">

        <!-- Header -->
        <div class="d-flex align-items-center bg-light border-5 rounded shadow-sm p-3 mb-1">
          <i class="bi bi-star-fill text-warning me-2"></i>
          <h6 class="fw-bold text-dark mb-0">Ratings & Reviews</h6>
        </div>

        <!-- Summary card -->
        <div class="card border-0 bg-light border rounded shadow p-2 p-lg-4 mb-3 mb-lg-2">
          <div class="row align-items-center g-3">
            <div class="col-4 col-lg-3 text-center">
              <h2 class="fw-bold text-dark lh-1 mb-1 text-nowrap">{{ rating || '0.0' }}</h2>
              
              <div class="text-warning mb-1 p-1 d-flex flex-nowrap justify-content-center">
                <span v-for="n in 5" :key="n">
                  <i class="bi" :class="n <= rating ? 'bi-star-fill' : 'bi-star'"></i>
                </span>
              </div>
              
              <div class="text-muted text-nowrap text-xs">{{ total_ratings }} reviews</div>
            </div>
            <div class="col-8 col-lg-9">
              <div v-for="star in [5,4,3,2,1]" :key="star" class="d-flex align-items-center gap-2 mb-1 mb-lg-2">
                <span class="text-muted text-xxs">{{ star }} ★</span>
                <div class="progress flex-grow-1 rounded-pill">
                  <div class="progress-bar bg-warning" :style="{ width: get_percentage(star) + '%' }"></div>
                </div>
                <span class="text-muted text-xxs">{{ get_percentage(star) }}%</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Rate form (visitor only) -->
        <div v-if="!user_has_rated && !isOwner"
          class="card border bg-light rounded-5 shadow p-3 p-lg-4 mb-3 mb-lg-4">
          <h6 class="fw-bold text-dark mb-1 d-flex align-items-center gap-2">
            <i class="bi bi-pencil-square text-primary"></i> Rate this Profile
          </h6>
          <p class="text-muted small mb-2 mb-lg-3">How was your overall experience?</p>

          <div class="d-flex align-items-center gap-1 mb-1 mb-lg-2">
            <i v-for="n in 5" :key="n" class="pointer"
              :class="n <= (hover_rating || new_rating) ? 'bi bi-star-fill text-warning' : 'bi bi-star text-secondary'"
              @mouseenter="hover_rating = n"
              @mouseleave="hover_rating = 0"
              @click="new_rating = n">
            </i>
          </div>

          <p class="text-muted small mb-2 mb-lg-3">{{ rating_level }}</p>

          <textarea v-model="new_review_text"
            class="form-control form-control-sm mb-3 rounded" rows="4"
            placeholder="Share your thoughts — reliability, communication..."></textarea>

          <div class="d-flex justify-content-end">
            <button class="btn btn-primary btn-sm fw-semibold rounded"
              :disabled="!new_rating || !new_review_text.trim()"
              @click="submit_rating">
              Submit Review
            </button>
          </div>
        </div>

        <!-- Reviews list -->
        <div class="scrollable-container">
          <div v-for="item in all_ratings" :key="item.id"
            class="card border bg-light rounded shadow-sm p-3 p-lg-4 mb-2">
            <div class="d-flex gap-2 gap-lg-3 border rounded p-1">

              <img :src="get_active_profile_picture(item.rater) || require('@/assets/images/user.png')" alt="Rater Avatar"
                class="profile-list-avatar pointer flex-shrink-0" />

              <div class="flex-grow-1 min-w-0">
                <div class="d-flex align-items-start justify-content-between mb-1">
                  <div class="d-flex flex-column pointer">
                  <div class="d-flex align-items-center gap-2 flex-wrap fw-bold ">
                    <span v-if="item?.rater?.profile_type?.toLowerCase().trim() === 'personal'"
                      @click="view_rater_profile(item?.rater?.user?.id)">
                      {{ item?.rater?.user?.first_name }} {{ item?.rater?.user?.last_name }}
                    </span>
                    <span v-else @click="view_company(item)">
                      {{ item?.rater?.company?.company_name || 'Company Name' }}
                    </span>
                    <span v-if="String(item.rater?.id) === String(active_profile_data.id)"
                      class="badge rounded-pill text-primary bg-primary-subtle border border-primary-subtle">You</span>
                  </div>
                  <span class="text-muted text-xxs mt-1 fw-semibold">{{ format_date(item.date_created) }}</span>
                </div>


                  <div class="dropdown">
                    <button v-if="String(item.rater?.id) === String(active_profile_data.id)" class="btn btn-sm btn-link text-muted p-0 lh-1 shadow-none" data-bs-toggle="dropdown">
                      <i class="bi bi-three-dots"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3">
                      <li>
                        <a class="dropdown-item small d-flex align-items-center gap-2" href="#"
                          @click.prevent="open_edit_reviews(item)">
                          <i class="bi bi-pencil text-muted"></i> Edit Review
                        </a>
                      </li>
                      <li><hr class="dropdown-divider my-1"></li>
                      <li>
                        <a class="dropdown-item small d-flex align-items-center gap-2 text-danger" href="#"
                          @click.prevent="delete_review(item)">
                          <i class="bi bi-trash"></i> Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="mb-1 mb-lg-2">
                  <i v-for="n in 5" :key="n"
                    :class="n <= item.rating ? 'bi-star-fill text-warning' : 'bi-star text-secondary'"></i>
                </div>

                <p class="text-primary mb-2">
                  {{ item.expanded ? item.comment : item.comment.slice(0, 120) + (item.comment.length > 120 ? '...' : '') }}
                  <span v-if="item.comment.length > 120"
                    class="text-decoration-underline pointer ms-1 small fw-semibold text-secondary"
                    @click="item.expanded = !item.expanded">
                    {{ item.expanded ? 'Show less' : 'Read more' }}
                  </span>
                </p>

                <!-- Replies -->
                <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
                  <button class="btn btn-link btn-sm text-primary p-0 shadow-none text-decoration-none text-xxs"
                    @click="item.show_replies = !item.show_replies">
                    <i class="bi bi-chat me-1"></i>
                    Reply<span v-if="item.replies && item.replies.length"> ({{ item.replies.length }})</span>
                  </button>
                </div>

                <div v-if="item.show_replies" class="mt-2 ps-2 border-start border-2">
                  <div v-for="reply in item.replies" :key="reply.id" class="d-flex gap-2 mb-2">
                    <img :src="get_active_profile_picture(reply.commenter)" alt="Reply Avatar"
                      class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0" />
                    <div class="flex-grow-1">
                      <div class="rounded p-2 px-3"
                        :class="reply.is_owner ? 'bg-primary-subtle border border-primary-subtle' : 'bg-white border'">
                        <div class="d-flex align-items-center gap-2 mb-1 text-xxs fw-bold">
                          <span v-if="reply.commenter.profile_type?.toLowerCase().trim() === 'personal'"
                            @click="view_profile(reply?.commenter?.user?.id)">
                            {{ reply?.commenter?.user?.first_name }} {{ reply?.commenter?.user?.last_name }}
                          </span>
                          <span v-else @click="view_company(reply)">
                            {{ reply?.commenter?.company?.company_name || 'Company Name' }}
                          </span>
                          <span v-if="reply.is_owner" class="badge bg-primary rounded-pill">Owner</span>
                        </div>
                        <p class="mb-0 text-primary text-xxs">{{ reply.comment }}</p>
                      </div>
                      <span class="text-muted ms-2 text-xxs">{{ reply.created_at }}</span>
                    </div>
                  </div>

                  <div class="d-flex gap-2 mt-2 align-items-center">
                    <input v-model="item.reply_draft" type="text"
                      class="form-control form-control-sm rounded-pill"
                      placeholder="Write a reply…"
                      @keyup.enter="submit_reply(item)">
                    <button class="btn btn-primary btn-sm rounded-pill px-3 fw-semibold flex-shrink-0"
                      @click="submit_reply(item)">
                      Send
                    </button>
                  </div>
                </div>
                <!-- End Replies -->

              </div>
            </div>
          </div>

          <!-- Empty state -->
          <div v-if="!all_ratings.length" class="text-center py-4 text-muted">
            <i class="bi bi-chat-dots fs-3 mb-2 d-block"></i>
            <div class="fw-semibold mb-1">No reviews yet</div>
          </div>
        </div>

      </div>
    </div>
      </div>
    </div>
    </div>
  </div>

  <teleport to="body">
  <div class="modal fade" id="profile_modal" tabindex="-1" aria-labelledby="profile_modallabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content shadow scrollable-container">
          <div class="modal-header bg-primary position-relative">
          <p class="modal-title text-xxs text-white" id="profile_modallabel">Edit information</p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="modal-body modal-body-scroll">
          <form @submit.prevent="saveProfile" id="profileForm" novalidate class="text-xxs">
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="first_name" ref="first_name" class="form-label fw-500">First Name<span class="text-danger">
                    *</span></label>
                <input type="text" class="form-control text-xxs rounded" id="first_name" v-model="user.first_name"
                  placeholder="First name" :class="{ 'is-invalid': errors.first_name }">
                <p v-if="errors.first_name" class="text-danger text-xxs">{{ errors.first_name }}</p>
              </div>
              <div class="col-md-6">
                <label for="last_name" ref="last_name" class="form-label fw-500">Last Name<span class="text-danger">
                    *</span></label>
                <input type="text" class="form-control text-xxs rounded" id="last_name" v-model="user.last_name"
                  placeholder="Last name" :class="{ 'is-invalid': errors.last_name }">
                <p v-if="errors.last_name" class="text-danger text-xxs">{{ errors.last_name }}</p>
              </div>
              <div class="col-md-6">
                <label for="email" ref="email" class="form-label fw-500">Email<span class="text-danger"> *</span></label>
                <input type="email" class="form-control text-xxs rounded" id="email" v-model="user.email"
                placeholder="Email" :class="{ 'is-invalid': errors.email }">
                <p v-if="errors.email" class="text-danger text-xxs">{{ errors.email }}</p>
              </div>
              <div class="col-md-6">
                <label for="date_of_birth" ref="date_of_birth" class="form-label fw-500">Date of Birth</label>
                <input type="date" class="form-control text-xxs rounded" id="date_of_birth" v-model="user.date_of_birth"
                :max="todayDate"
                :min="minDate"
                  placeholder="Date of birth" :class="{ 'is-invalid': errors.date_of_birth }">
                <p v-if="errors.date_of_birth" class="text-danger text-xxs">{{ errors.date_of_birth }}</p>
              </div>
              <div class="col-md-6">
                <label for="phone_number" ref="phone_number" class="form-label fw-500">Phone Number</label>
                <input type="text" class="form-control text-xxs rounded" id="phone_number" v-model="user.phone_number"
                  placeholder="Phone number" :class="{ 'is-invalid': errors.phone_number }">
                <p v-if="errors.phone_number" class="text-danger text-xxs">{{ errors.phone_number }}</p>
              </div>
              <div class="col-md-6">
                <label for="race_id" ref="race_id" class="form-label fw-500">Race</label>
                <select class="form-control text-xxs rounded" id="race_id" v-model="race_id"
                  :class="{ 'is-invalid': errors.race_id }">
                  <option class="text-muted" value="">Select Race</option>
                  <option v-for="race in races" :value="race.id" :key="race.id">
                    {{ race.race }}
                  </option>
                </select>
                <p v-if="errors.race_id" class="text-danger text-xxs">{{ errors.race_id }}</p>
              </div>
              <div class="col-md-6">
                <label for="gender_id" ref="gender_id" class="form-label fw-500">Gender</label>
                <select class="form-control text-xxs rounded" id="gender_id" v-model="user.gender_id"
                  :class="{ 'is-invalid': errors.gender_id }">
                  <option class="text-muted" value="">Select Gender</option>
                  <option v-for="gender in genders" :value="gender.id" :key="gender.id">{{ gender.gender }}</option>
                </select>
                <p v-if="errors.gender_id" class="text-danger text-xxs">{{ errors.gender_id }}</p>
              </div>
              <div class="col-md-6">
                <label for="title" ref="title_id" class="form-label fw-500">Title</label>
                <select class="form-control text-xxs rounded" id="title" v-model="title_id"
                  :class="{ 'is-invalid': errors.title_id }">
                  <option class="text-muted" value="">Select Title</option>
                  <option v-for="title in titles" :value="title.id" :key="title.id">{{ title.title }}</option>
                </select>
                <p v-if="errors.title_id" class="text-danger text-xxs">{{ errors.title_id }}</p>
              </div>
              <div class="col-md-6 d-none">
                <label for="street_address" ref="street_address" class="form-label fw-500">Street Address</label>
                <input type="text" class="form-control text-xxs rounded" id="street_address"
                  v-model="address.street_address" placeholder="Street address"
                  :class="{ 'is-invalid': errors.street_address }">
                <p v-if="errors.street_address" class="text-danger text-xxs">{{ errors.street_address }}</p>
              </div>
              <div class="col-md-6 d-none">
                <label for="town" ref="town" class="form-label fw-500">Town<span class="text-danger"> *</span></label>
                <input type="text" class="form-control text-xxs rounded" id="town" v-model="address.town"
                  placeholder="Town" :class="{ 'is-invalid': errors.town }">
                <p v-if="errors.town" class="text-danger text-xxs">{{ errors.town }}</p>
              </div>
              <div class="col-md-6 d-none">
                <label for="postal_code" ref="postal_code" class="form-label fw-500">Postal Code<span
                    class="text-danger"> *</span></label>
                <input type="text" class="form-control text-xxs rounded" id="postal_code" v-model="address.postal_code"
                  placeholder="Postal code" :class="{ 'is-invalid': errors.postal_code }">
                <p v-if="errors.postal_code" class="text-danger text-xxs">{{ errors.postal_code }}</p>
              </div>
              <div class="col-md-6">
                <label for="mapSearchBox" class="form-label text-xxs fw-500 d-block">Search for Location</label>
                <input id="mapSearchBox" type="text" class="form-control rounded text-xxs"
                  placeholder="Search location..." v-model="location" />
              </div>
              <p v-if="errors.location" class="text-danger text-xxs">{{ errors.location }}</p>
              <div class="col-md-6">
                <label for="province_id" ref="province_id" class="form-label fw-500">Province</label>
                <select class="form-control text-xxs rounded" id="province_id" v-model="address.province_id"
                  :class="{ 'is-invalid': errors.province_id }">
                  <option class="text-muted" value="">Select Province</option>
                  <option v-for="province in provinces" :value="province.id" :key="province.id">
                    {{ province.province_name }}
                  </option>
                </select>
                <p v-if="errors.province_id" class="text-danger text-xxs">{{ errors.province_id }}</p>
              </div>
            </div>
            <div class="text-end">
              <button type="submit" class="btn btn-primary text-white text-xxs shadow-sm rounded">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  </teleport>
<teleport to="body">
  <div id="manage-subscription-modal" class="modal fade " tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content rounded shadow">
        <div class="modal-header ">
          <h5 class="modal-title ">Manage Subscription</h5>
          <button class="close-button" type="button" data-bs-dismiss="modal" aria-label="Close">
            <i class="bi bi-x fw-bold"></i>
          </button>
        </div>

        <div class="modal-body modal-body-scroll">
          <!-- Current Plan Info -->
          <div class="alert bg-transparent bg-opacity-10 border-secondary border-opacity-25 mb-4">
            <div class="d-flex align-items-center mb-2">
              <div class="d-flex align-items-center">
                <div :class="[
                    'rounded-circle me-2',
                    is_active ? 'bg-success' : 'bg-danger'
                  ]" style="width: 12px; height: 12px;"></div>
                <span :class="['fw-semibold', is_active ? 'text-success' : 'text-danger']">
                  {{ membership_name }} - {{ is_active ? 'Active' : 'Inactive' }}
                </span>
              </div>

            </div>
            <div v-if="is_active" class="small text-muted">
              <div>{{billing_cycle}} billing • Renews {{formatDate(renewal_date)}}</div>
              <div>Next charge: R{{membership_price}} on {{formatDate(renewal_date)}}</div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-grid gap-2">
<div v-if="!is_active"
     @click="navigate_to_plans"
     class="btn btn-outline-secondary d-flex justify-content-between align-items-center p-3 text-start text-decoration-none">
  <div class="d-flex align-items-center">
    <i class="bi bi-graph-up text-muted me-3"></i>
    <span class="fw-medium text-dark">View All Plans</span>
    <span class="small text-muted">Compare features and pricing</span>
  </div>
  <button class="btn gradient-btn text-white px-3 py-2 rounded shadow-sm ">
    {{ is_active ? 'Upgrade' : 'Renew' }}
  </button>
</div>


            <button v-if="is_active" class="btn btn-outline-danger d-flex justify-content-between align-items-center p-3 text-start"
              @click="cancel_membership">
              <div class="d-flex align-items-center">
                <i class="bi bi-exclamation-triangle me-3"></i>
                <span class="fw-medium">Cancel Subscription</span>
              </div>
            </button>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer border-top">
          <div class="text-center w-100 small text-muted">
            Questions about your subscription?
            <a href="#" class="text-warning text-decoration-none">Contact Support</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
<!-- Visibility Modal -->
<div class="modal fade" id="visibility_modal" tabindex="-1" aria-labelledby="visibilityModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded shadow border-0">
      <!-- Header -->
      <div class="modal-header border-bottom-0">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Body -->
      <div class="modal-body pb-0">
        <p class="mb-3 text-muted d-flex align-items-center gap-1">
          <i class="bi bi-info-circle"></i>
          Choose who can see this information on your profile.
        </p>

        <div class="form-check mb-3 p-3 rounded border bg-light d-flex align-items-start">
          <input class="form-check-input me-2 mt-1" type="radio" id="public" value="true" v-model="currentVisibility">
          <label class="form-check-label fw-medium" for="public">
            <i class="bx bx-globe me-1"></i> Public
            <div class="small text-muted">Anyone can see this field.</div>
          </label>
        </div>

        <div class="form-check p-3 rounded border bg-light d-flex align-items-start">
          <input class="form-check-input me-2 mt-1" type="radio" id="private" value="false" v-model="currentVisibility">
          <label class="form-check-label fw-medium" for="private">
            <i class="bx bxs-lock-alt me-1"></i> Only Me
            <div class="small text-muted">Only you can see this field.</div>
          </label>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer border-0 pt-0 mt-3">
        <button class="btn btn-secondary btn-sm text-xxs shadow-sm d-flex align-items-center gap-1 mt-3" data-bs-dismiss="modal">
         Cancel
        </button>
        <button class="btn btn-primary btn-sm text-xxs shadow-sm d-flex align-items-center gap-1 mt-3" @click="save_field_visibility">
           Save
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="answer_visibility_modal" tabindex="-1" aria-labelledby="answerVisibilityModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded shadow border-0">

      <!-- Header -->
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title" id="answerVisibilityModalLabel">Set Answer Visibility</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Body -->
      <div class="modal-body pb-0">
        <p class="mb-3 text-muted d-flex align-items-center gap-2">
          <i class="bi bi-info-circle"></i>
          Choose who can see this answer on your profile.
        </p>

        <div class="form-check mb-3 p-3 rounded border bg-light d-flex align-items-start">
          <input
            class="form-check-input me-2 mt-1"
            type="radio"
            id="answer_public"
            :value="true"
            v-model="currentAnswerVisibility"
          />
          <label class="form-check-label fw-medium" for="answer_public">
            <i class="bx bx-globe me-1"></i> Public
            <div class="small text-muted">Anyone can see this answer.</div>
          </label>
        </div>

        <div class="form-check p-3 rounded border bg-light d-flex align-items-start">
          <input
            class="form-check-input me-2 mt-1"
            type="radio"
            id="answer_private"
            :value="false"
            v-model="currentAnswerVisibility"
          />
          <label class="form-check-label fw-medium" for="answer_private">
            <i class="bx bxs-lock-alt me-1"></i> Only Me
            <div class="small text-muted">Only you can see this answer.</div>
          </label>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer border-0 pt-0 mt-3">
        <button class="btn btn-secondary btn-sm text-xxs shadow-sm d-flex align-items-center gap-1 mt-3" data-bs-dismiss="modal">
          Cancel
        </button>
        <button class="btn btn-primary btn-sm text-xxs shadow-sm d-flex align-items-center gap-1 mt-3" @click="save_answer_visibility">
          Save
        </button>
      </div>

    </div>
  </div>
</div>
</teleport>



        <!-- 🖼 Added moved modals -->
<teleport to="body">
  <div class="modal fade"
  id="cover_picture_modal" tabindex="-1"
  aria-labelledby="cover_picture_modal_label"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content shadow scrollable-container">
          <div class="modal-header bg-primary position-relative">
        <p class="modal-title text-white text-xxs" id="cover_picture_modal_label">Preview Banner Picture</p>
         <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <div class="modal-body text-center">
        <img
          :src="cover_picture_preview"
          alt="Preview"
          class="rounded-circle w-75 h-75"
        />
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary btn-sm text-xxs rounded" @click="upload_profile_banner">Save</button>
      </div>
    </div>
  </div>
</div>
  </teleport>

<!-- Modal Preview -->
 <teleport to="body">
<div
  class="modal fade"
  id="image_preview_modal"
  tabindex="-1"
  aria-labelledby="image_preview_modal_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded shadow scrollable-container">
      <div class="modal-header bg-primary position-relative">
        <p class="modal-title text-xxs text-white" id="image_preview_modal_label">Profile Picture</p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <div class="modal-body text-center p-2">
           <div v-if="profile_picture_preview">
              <img :src="profile_picture_preview" class="rounded w-100 shadow-sm border" />
            </div>
            <div v-else>
              <img :src="image_view_url" alt="Image" class="rounded w-100 shadow-sm border" />
            </div>
        </div>
      <div v-if="isOwner" class="modal-footer border-0 p-3 d-flex justify-content-end gap-2">
            <!-- If there is a preview, show full-width Save button -->
            <button v-if="profile_picture_preview" class="btn btn-sm btn-primary text-xs rounded w-100 py-2"
              @click="upload_profile_picture()">
              Upload
            </button>

            <!-- If no preview, show Upload and Delete side by side -->
            <div v-else class="d-flex gap-2">
              <button class="btn btn-sm btn-primary rounded text-xxs flex-fill py-2 " @click="triggerFileUpload">
                Upload
              </button>
              <button class="btn btn-sm btn-primary text-xxs rounded flex-fill py-2 "
                @click="delete_profile_image('profile_picture')">
                Delete
              </button>
            </div>

          </div>
    </div>
  </div>
</div>
 </teleport>

 <teleport to="body">
  <div  class="modal fade" id="follower_modal" tabindex="-1" aria-labelledby="followersModalLeble" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content scrollable-container rounded">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title fw-bold text-white">{{ type_of_followers ? 'Followers' : 'Following' }}</h5>
          <button type="button" class="btn-close bg-light" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body modal-body-scroll p-4">
          
          <div v-if="loading_followers" class="text-center p-4">
            <div class="spinner-border text-primary" role="status"></div>
          </div>

          <ul v-else-if="followers_list.length" class="list-group list-group-flush">
            <li v-for="follow in followers_list" :key="follow.id" class="list-group-item p-3 mb-2 border rounded">
            
            <div v-for="profile in [type_of_followers ? follow.follower : follow.target]" :key="profile.id" 
                class="d-flex align-items-center gap-3 w-100">
              
              <div class="avatar-sm mb-1">
                <img  
                      :src="get_active_profile_picture(profile) || require('@/assets/images/user.png')" 
                      class="rounded-circle border shadow-sm object-fit-cover" 
                      width="48" height="48"
                      alt="logo">
              </div>

              <div>
                <h6 v-if="profile?.profile_type == 'business'" class="mb-0 fw-bold ms-2 mt-2">
                  {{ profile?.company?.company_name }}
                </h6>
                <h6 v-else class="mb-0 fw-bold ms-2 mt-2">
                  {{ profile?.user?.first_name }} {{ profile?.user?.last_name }}
                </h6>
              </div>

            </div>
            
          </li>
          </ul>

          <div v-else class="text-center p-5 text-muted">
            <i class="bi bi-people d-block mb-2 fs-2"></i>
            <p>{{ type_of_followers ? 'No followers found yet.' : 'No following found yet.' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
  <teleport to="body">
   <div
      id="ratings-modal"
      class="modal fade "
      tabindex="-1"
      role="dialog"
      aria-modal="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content rounded-5 shadow scrollable-container">
          <div class="modal-header bg-primary position-relative">
            <p class="modal-title text-white text-xxs">Reviews</p>
             <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal"
              aria-label="Close">
            </button>
          </div>

          <div class="modal-body modal-body-scroll">
            <!-- Ratings list -->
             <div v-if="all_ratings.length > 0">
            <div
              v-for="item in all_ratings"
              :key="item.id"
              class="mb-3 d-flex align-items-start gap-3"
            >
              <img
                :src="get_active_profile_picture(item.rater)"
                alt="Profile Picture"
                class="rounded-circle profile-list-avatar"
              />
              <div>
                <div>
                  <span v-for="n in 5" :key="n" class="text-warning">
                    <i v-if="n <= item.rating" class="bi bi-star-fill"></i>
                    <i v-else class="bi bi-star"></i>
                  </span>
                </div>
                <div class="d-flex align-items-center gap-2 flex-wrap pointer">
                  <span v-if="item?.rater?.profile_type?.toLowerCase().trim() === 'personal'"
                    >
                    {{ item?.rater?.user?.first_name }} {{ item?.rater.base_profile?.user?.last_name }}
                  </span>
                  <span v-else>
                    {{ item?.rater?.company?.company_name || 'Company Name' }}
                  </span>
                </div>
                <div v-if="item.comment" class="mt-1 text-xxs fw-500">{{ item.comment }}</div>
              </div>
            </div>
            </div>

            <!-- Fallback when there are no reviews -->
            <div v-if="all_ratings.length === 0" class="text-center py-4 text-muted">
              <i class="bi bi-chat-dots fs-3 mb-2"></i>
              <div class="fw-semibold mb-1">No reviews yet</div>
            </div>

            <!-- If user hasn't rated, show rating input inside modal -->
            <!-- User Rating Input (if not rated yet) -->
        <div v-if="!user_has_rated && !isOwner" class="mt-1">
          <div class="stars mb-4">
            <input type="radio" id="star5" name="rating" value="5" v-model="userRating" />
            <label :class="{ checked: userRating >= 5 }" for="star5" title="5 stars"></label>

            <input type="radio" id="star4" name="rating" value="4" v-model="userRating" />
            <label :class="{ checked: userRating >= 4 }" for="star4" title="4 stars"></label>

            <input type="radio" id="star3" name="rating" value="3" v-model="userRating" />
            <label :class="{ checked: userRating >= 3 }" for="star3" title="3 stars"></label>

            <input type="radio" id="star2" name="rating" value="2" v-model="userRating" />
            <label :class="{ checked: userRating >= 2 }" for="star2" title="2 stars"></label>

            <input type="radio" id="star1" name="rating" value="1" v-model="userRating" />
            <label :class="{ checked: userRating >= 1 }" for="star1" title="1 star"></label>
          </div>

          <textarea
            v-model="comment"
            placeholder="Write a comment..."
            rows="3"
            class="form-control mb-2"
          ></textarea>

          <button
            class="btn btn-primary"
            @click="submitRating"
            :disabled="!userRating"
          >
            Submit Rating
          </button>
        </div>

          </div>
        </div>
      </div>
    </div>
 </teleport>

 <teleport to="body">
    <div class="modal fade" id="social_modal" tabindex="-1" aria-labelledby="social_modal_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shadow scrollable-container rounded">

          <div class="modal-header bg-primary position-relative">
            <h5 class="modal-title fw-bold text-white" id="social_modal_label">
              <span>Add Social Links</span>
            </h5>
            <button type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-3"
              data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>

          <div class="modal-body modal-body-scroll p-4">
            <label class="form-label fw-bold text-dark mb-3">Social Links</label>

            <div v-for="(link, index) in new_socials" :key="index" class="row g-2 align-items-center mb-3">
              <div class="col-12 col-md-4">
                <select v-model="link.platform" class="form-select rounded-3 bg-light">
                  <option value="" disabled>Select platform</option>
                  <option v-for="type in social_platforms" :key="type.id" :value="type.id">
                    {{ type.name }}
                  </option>
                </select>
              </div>

              <div class="col-10 col-md-7">
                <input type="url" v-model="link.url" class="form-control rounded bg-light"
                  placeholder="Enter profile link">
                <p v-if="errors.social_link" class="text-danger text-xxs">{{ errors.social_link }}</p>
              </div>

              <div class="col-2 col-md-1 text-end text-md-center">
                <i class="bi bi-trash text-danger fs-5 pointer" @click="remove_row(index)" title="Remove"></i>
              </div>
            </div>

            <button type="button" class="btn btn-secondary mt-1 rounded btn-sm" @click="add_social_row">
              <i class="bi bi-plus-circle me-1"></i>
              Add Social Link
            </button>
          </div>
          <div class="modal-footer border-0 pt-0 pb-4 px-4 d-flex justify-content-between">
            <button type="button" class="btn btn-light rounded px-4 fw-bold" data-bs-dismiss="modal">Cancel</button>

            <button type="button" class="btn btn-sm btn-primary rounded " @click="save_social_profiles">
              Save Links
            </button>
          </div>

        </div>
      </div>
    </div>
  </teleport>


<div class="modal fade" id="image_view_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered image-modal-dialog">
      <div class="modal-content border-0 rounded image-modal-content">

        <div class="modal-header border-0">
          <h5 class="modal-title" id="image_view_modal">Profile Picture</h5>

          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-0">
          <img
          :src="image_view_url"
          alt="Image"
          class="img-fluid rounded d-block image-preview"
          />
          <i
          v-if="isOwner"
          class="bi bi-camera text-primary position-absolute top-0 end-0 m-3 bg-white p-1 rounded-circle"
          @click="triggerFileUpload"
          ></i>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="image_view_cover" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content shadow scrollable-container">

        <div class="modal-header border-0 pb-0">
            <p class="modal-title fw-bold text-black">Banner Image</p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" @click="profiles_modal_close"></button>
          </div>

          <div class="modal-body text-center p-2">
           <div v-if="cover_picture_preview">
              <img :src="cover_picture_preview" class="rounded w-100 shadow-sm border" />
            </div>
            <div v-else>
              <img :src="image_view_url" alt="Image" class="rounded w-100 shadow-sm border" />
            </div>
        </div>
        <div v-if="isOwner" class="modal-footer border-0 p-3 d-flex justify-content-end gap-2">
            <!-- If there is a preview, show full-width Save button -->
            <button v-if="cover_picture_preview" class="btn btn-sm btn-primary text-xs rounded w-100 py-2"
              @click="upload_profile_banner()">
              Upload
            </button>

            <!-- If no preview, show Upload and Delete side by side -->
            <div v-else class="d-flex gap-2">
              <button class="btn btn-sm btn-primary rounded text-xxs flex-fill py-2 " @click="triggerFileUploadCover">
                Upload
              </button>
              <button class="btn btn-sm btn-primary text-xxs rounded flex-fill py-2 "
                @click="delete_profile_image('cover_picture')">
                Delete
              </button>
            </div>

          </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="view_answer_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content border-0 rounded">

      <div class="modal-header border-0">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body p-0 ">

        <!-- 🖼 Image Preview -->
        <div v-if="is_image_file(answer_file_name)">
          <img
            :src="image_view_url"
            alt="Image"
            class="img-fluid rounded mx-auto d-block"
          />
        </div>
        <div v-else-if="is_pdf_file(answer_file_name)">
          <iframe :src="image_view_url" class="w-100"
            height="600" frameborder="0"></iframe>
        </div>
        <div v-else-if="is_office_file(answer_file_name)">
          <iframe :src="`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(image_view_url)}`"
            class="w-100" height="600" frameborder="0"></iframe>
        </div>

       <div v-else>
        <div class="p-4 text-center">
          <p class="fw-semibold mb-2">{{ answer_file_name }}</p>
          <p class="text-muted mb-3">
            Preview not available for this file type.
          </p>
          <a :href="image_view_url" target="_blank" class="btn btn-primary rounded-pill">
            Download File
          </a>
        </div>
      </div>

      </div>
    </div>
  </div>
</div>
</div>
